import { render, staticRenderFns } from "./OrderDetailTable.vue?vue&type=template&id=4f7e5283&"
import script from "./OrderDetailTable.vue?vue&type=script&lang=js&"
export * from "./OrderDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports